
import React, { Fragment } from 'react'

import ArrowDown from '../../SvgImages/ArrowDown'

import './InputSelect.scss'

interface Props {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  options?: any[]
  renderOption?: (option: any) => React.ReactNode
  disabled?: boolean
}

const InputSelect = (props: Props) => {

  const {
    value,
    onChange,
    placeholder,
    className = '',
    options,
    renderOption,
    disabled,
  } = props

  return (
    <div className="input-select">
      <div className="arrow-down">
        <ArrowDown width={16} height={16} />
      </div>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`input-select ${className}`}
        disabled={disabled}
      >
        {placeholder && (
          <option value="">
            {placeholder}
          </option>
        )}
        {renderOption && options?.map((option: any, i: number) => (
          <Fragment key={i}>
            {renderOption(option)}
          </Fragment>
        ))}
        {!renderOption && options?.map((option: any) => (
          <option key={option._id} value={option._id}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  )
}

export default InputSelect